//1.导入vue和router包
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
        {                    //每一个链接都是一个对象
            path: '/login',         //链接路径
            name: 'login',  
            meta: { title: '欢迎使用跨境业务中台：登录' },   //路由名称，
            component: () => import('@/views/login.vue'),   //对应的组件模板
        },
        {
            path: '/403',
            name: 'error403',
            meta: { title: '403' },
            component: () => import('@/views/Error/403.vue'),
        },
        {  
            path: '/:id?',
            name:'frame',
            component: () => import('@/views/home.vue'),
        }, 
        {  
            path: '/basic/authSuccess',
            name:'basic',
            component: () => import('@/views/success.vue'),
        }, 
        {  
            path: '/basic/authFailure',
            name:'basic',
            component: () => import('@/views/fail.vue'),
        }, 
    ];
    
    const router = new VueRouter({
        // mode: 'history',
        // base: process.env.BASE_URL,
        routes
    });
    
    // 使用 beforeEach 添加路由守卫
    router.beforeEach((to, from, next) => {
        const token = localStorage.getItem('token'); // 假设token存储在localStorage中
        if (to.meta && to.meta.title) {
            document.title = to.meta.title // 设置页面标题
        }
        if (to.path !== '/login' && !token) {
          next('/login'); // 如果去往非登录页面且没有token，重定向到登录页面
        } else {
          next(); // 否则，正常导航
        }
    });
    
    export default router;